// extracted by mini-css-extract-plugin
module.exports = {"box":"CustomDialogWrapper_box_5-g2B","content":"CustomDialogWrapper_content_3ot0l","title":"CustomDialogWrapper_title_2s0wr","footer":"CustomDialogWrapper_footer_2yP_x"};